import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  ADD_CURRENCY_PAIR,
  UPDATE_CURRENCY_PAIR,
  FETCH_CURRENCY_PAIRS,
  DELETE_CURRENCY_PAIR,
} from "../../Action/actionTypes";
import {
  addCurrencyPairSuccess,
  addCurrencyPairFailure,
  updateCurrencyPairSuccess,
  updateCurrencyPairFailure,
  fetchCurrencyPairsSuccess,
  fetchCurrencyPairsFailure,
  deleteCurrencyPairSuccess,
  deleteCurrencyPairFailure,
} from "../../Action/transaction/currencyPairsAction";
import { notifyError, notifyPromise } from "../../../Utils/Helper";

function* addCurrencyPairRequest(action) {
  try {
    const { payload } = action;
   
    const promise = API.post("/add-currency-pair", payload);
    const res = yield call(notifyPromise, promise, "Adding currency pair...");
    const data = res?.data;

    if (data?.meta?.code === 200) {
      yield put(addCurrencyPairSuccess(data?.data));
      if (payload?.callback) {
        yield call(payload.callback, data);
      }
    } else {
      yield put(addCurrencyPairFailure(data?.meta?.message || "Failed to add currency pair"));
    }
  } catch (error) {
    yield put(addCurrencyPairFailure(error.message));
    yield call(notifyError, "Error adding currency pair");
  }
}

// Update Currency Pair Saga
function* updateCurrencyPairRequest(action) {
  try {
    const { payload } = action;
    const promise = API.put(`/currency-pairs/update/${payload._id}`, payload);
    const res = yield call(notifyPromise, promise, "Updating currency pair...");
    const data = res?.data;

    if (data?.meta?.code === 200) {
      yield put(updateCurrencyPairSuccess(data?.data));
      if (payload?.callback) {
        yield call(payload.callback, data);
      }
    } else {
      yield put(updateCurrencyPairFailure(data?.meta?.message || "Failed to update currency pair"));
    }
  } catch (error) {
    yield put(updateCurrencyPairFailure(error.message));
    yield call(notifyError, "Error updating currency pair");
  }
}

// Fetch Currency Pairs Saga
function* fetchCurrencyPairsRequest(action) {
  try {
    const { whitelabelId } = action.payload || {};
    let url = "/currency-pairs";
    
    if (whitelabelId) {
      url = `/currency-pairs?whitelabelId=${whitelabelId}`;
    }
    
    const res = yield API.get(url);
    const data = res?.data;

    if (data?.meta?.code === 200) {
      yield put(fetchCurrencyPairsSuccess(data?.data));
    } else {
      yield put(fetchCurrencyPairsFailure(data?.meta?.message || "Failed to fetch currency pairs"));
    }
  } catch (error) {
    yield put(fetchCurrencyPairsFailure(error.message));
  }
}

// Delete Currency Pair Saga
function* deleteCurrencyPairRequest(action) {
  try {
    const { payload } = action;
    let url = `/currency-pairs/${payload.id}`;
    
    // If whitelabelId is provided, add it as a query parameter
    if (payload.whitelabelId) {
      url = `/currency-pairs/${payload.id}?whitelabelId=${payload.whitelabelId}`;
    }
    
    const res = yield API.delete(url);
    const data = res?.data;

    if (data?.meta?.code === 200) {
      yield put(deleteCurrencyPairSuccess(payload.id));
      if (payload?.callback) {
        yield call(payload.callback, data);
      }
    } else {
      yield put(deleteCurrencyPairFailure(data?.meta?.message || "Failed to delete currency pair"));
    }
  } catch (error) {
    yield put(deleteCurrencyPairFailure(error.message));
    yield call(notifyError, "Error deleting currency pair");
  }
}

// Watchers
export function* watchAddCurrencyPair() {
  yield takeEvery(ADD_CURRENCY_PAIR, addCurrencyPairRequest);
}

export function* watchUpdateCurrencyPair() {
  yield takeEvery(UPDATE_CURRENCY_PAIR, updateCurrencyPairRequest);
}

export function* watchFetchCurrencyPairs() {
  yield takeEvery(FETCH_CURRENCY_PAIRS, fetchCurrencyPairsRequest);
}

export function* watchDeleteCurrencyPair() {
  yield takeEvery(DELETE_CURRENCY_PAIR, deleteCurrencyPairRequest);
}

export default function* rootSaga() {
  yield all([
    watchAddCurrencyPair(),
    watchUpdateCurrencyPair(),
    watchFetchCurrencyPairs(),
    watchDeleteCurrencyPair(),
  ]);
}